import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

interface Product {
  id: number
  image: string
  name: string
  sku: string
  created_at: string
  currency: number
  description: string
  stats: any
  active: boolean
  unique_name: string
  category_id: number
  desc_details: any
  price: number
  in_stock: boolean
  salon: number
  stock_quantity: number
  min_stock_level: number
  warehouse: number
  reorder: number
  brand: number
  sale_price: number
  updated_at: string
  subcategory_id: number
  store_id: string
  instruction: string
  ingredients: string
}

const getProductsByCategory = async (categoryId: number | string) => {
  const { data, error } = await supabase
    .from('products')
    .select('*')
    .eq('category_id', categoryId)
    .eq('active', true)

  if (error) {
    throw new Error(error.message)
  }

  return data as Product[]
}

export default function useGetProductsByCategoryId(categoryId: number | string | null) {
  return useQuery({
    queryKey: ['useGetProductsByCategoryId', categoryId],
    queryFn: () => getProductsByCategory(categoryId!),
    staleTime: 0,
    enabled: !!categoryId
  })
}